import { NameValue } from "../models/name-value.model";

export const NpsToDn = {
    _1_8: {name: '1/8', value: 6, index: 0} as NameValue,
    _1_4: {name: '1/4', value: 8, index: 1} as NameValue,
    _3_8: {name: '3/8', value: 10, index: 2} as NameValue,
    _1_2: {name: '1/2', value: 15, index: 3} as NameValue,
    _3_4: {name: '3/4', value: 20, index: 4} as NameValue,
    _1: {name: '1', value: 25, index: 5} as NameValue,
    _1_1_4: {name: '1 1/4', value: 32, index: 6} as NameValue,
    _1_1_2: {name: '1 1/2', value: 40, index: 7} as NameValue,
    _2: {name: '2', value: 50, index: 8} as NameValue,
    _2_1_2: {name: '2 1/2', value: 65, index: 9} as NameValue,
    _3: {name: '3', value: 80, index: 10} as NameValue,
    _3_1_2: {name: '3 1/2', value: 90, index: 11} as NameValue,
    _4: {name: '4', value: 100, index: 12} as NameValue,
    _5: {name: '5', value: 125, index: 13} as NameValue,
    _6: {name: '6', value: 150, index: 14} as NameValue,
    _8: {name: '8', value: 200, index: 15} as NameValue,
    _10: {name: '10', value: 250, index: 16} as NameValue,
    _12: {name: '12', value: 300, index: 17} as NameValue,
    _14: {name: '14', value: 350, index: 18} as NameValue,
    _16: {name: '16', value: 400, index: 19} as NameValue,
    _18: {name: '18', value: 450, index: 20} as NameValue,
    _20: {name: '20', value: 500, index: 21} as NameValue,
    _22: {name: '22', value: 550, index: 22} as NameValue,
    _24: {name: '24', value: 600, index: 23} as NameValue
}